import { TAILLE_MAX_FICHIER_MO, jeuCouvreLaFiche, libelleDesTypes, politiquesFusionnees, tailleMaxOctets, typeDeFichierAccepte } from '@taki/data-model';
import type { AppFieldsFile, FichiersDeJeu } from '@taki/data-model';

/**
 * LA CAPACITE FICHIERS D'UNE PORTE, lue sur la declaration EFFECTIVE (celle de
 * l'org quand elle en a une) : la politique la plus large des jeux qui decrivent
 * cette famille et ce type, ou `null` quand aucun ne l'ouvre. `null` retire la
 * carte des fichiers de la fiche ; le serveur, lui, refuse deja l'ajout.
 */
export function politiqueDeFichiers(
  champs: Pick<AppFieldsFile, 'jeux'>,
  jeu: { family: string; type?: string | undefined } | null,
): FichiersDeJeu | null {
  if (jeu === null) return null;
  return politiquesFusionnees(
    champs.jeux.filter((declare) => jeuCouvreLaFiche(declare, jeu.family, jeu.type)).map((declare) => declare.fichiers),
  );
}

/**
 * LE REFUS COTE CLIENT, avant tout envoi : la meme regle que le serveur
 * (`jeux[].fichiers`), dite en une phrase. Le serveur reste juge ; ceci evite
 * seulement d'envoyer 20 Mo pour se les voir refuser. `null` : le fichier passe.
 */
export function refusDeFichier(politique: FichiersDeJeu, file: { name: string; type: string; size: number }): string | null {
  if (!typeDeFichierAccepte(politique, file.type || 'application/octet-stream')) {
    return `« ${file.name} » n'est pas accepté ici : ${libelleDesTypes(politique)} seulement.`;
  }
  if (file.size > tailleMaxOctets(politique)) {
    return `« ${file.name} » dépasse ${politique.tailleMaxMo ?? TAILLE_MAX_FICHIER_MO} Mo, la taille maximale ici.`;
  }
  return null;
}
